export default "__VITE_ASSET__DVojiFJT__"